export default {
  evaluation_dashboard: {
    title: '평가 의뢰 대시보드',
    unit: '사',
    average: '평균:',
    point: '점',
    answered_label: '응답 완료',
    evaluated_label: '평가 완료',
    // corporate_average: "",
    points_earned_by_companies: '평가 의뢰 기업의 획득 점수 분포',
    year_modal: {
      title: '대상 연도를 선택해 주세요.',
      label: '대상 연도',
    },
    response_status_title: '응답 상태 분포',
    response_status_rating_nothing: 'ESG 등급 평가 완료인 기업이 없습니다',
    esg_rating_title: 'ESG 등급 분포',
    esg_score_title: 'ESG 스코어 분포',
    category_scores_title: '카테고리별 스코어 비교',
    category_scores_distribution_title: '카테고리별 스코어 분포',
    category_score_data_all_label: '아스에네 ESG가 평가한 모든 기업',
    esg_scores_by_industry_title: '업종별 ESG 스코어 분포',
    environment_score_title: '환경 스코어 분포',
    social_score_title: '사회 스코어 분포',
    governance_score_title: '거버넌스 스코어 분포',
    environment_score_subtitle_upper5: '환경 스코어 상위 5사',
    environment_score_subtitle_lower5: '환경 스코어 하위 5사',
    social_score_subtitle_upper5: '사회 스코어 상위 5사',
    social_score_subtitle_lower5: '사회 스코어 하위 5사',
    governance_score_subtitle_upper5: '거버넌스 스코어 상위 5사',
    governance_score_subtitle_lower5: '거버넌스 스코어 하위 5사',
    // empty_error_message: "",
    common: {
      companies: '사',
      update_date: '갱신 일시',
    },
    registration_rate: {
      title: '등록률',
      tip: '조사 대상 기업 수 대비 아스에네 ESG에 등록된 피평가 기업 수의 비율',
    },
    answer_rate: {
      title: '응답률',
      tip: '조사 대상 기업 수 대비 응답을 제출한 피평가 기업 수의 비율',
    },
    days_remaining: {
      title: '조사 종료까지의 일수',
      tip: '설정된 응답 기한까지의 일수.\n응답 기한을 변경하고자 하는 경우는 문의해 주세요.',
      days_remaining_before: '앞으로',
      days_remaining_after: '일',
      expired: '응답 기한을 초과했습니다',
    },
    answer_transition: {
      title: '응답 추이',
      companies_submitted: '응답 기업 수',
      breakdown: '내역',
      unregistered: '미등록',
      total: '총',
      number_of_companies: '기업 수',
    },
    answer_list: {
      title: '최신 응답 데이터',
      submitted_at: '응답 일시',
    },
  },
}
